import { StaticJsonRpcProvider, Web3Provider } from '@ethersproject/providers'
import { BigNumber } from 'ethers'
import { getSISContract } from '~/contracts/getSISContract'
import { FeeDistributor } from '~/contracts/types'
import { VESISConfig } from '~/types/config'

export async function getWeeklySISDistribution(
	config: VESISConfig,
	provider: Web3Provider | StaticJsonRpcProvider,
	feeDistributorContract: FeeDistributor
): Promise<BigNumber> {
	const { week } = config

	const sisContract = getSISContract(config, provider)
	const balance = await sisContract.balanceOf(feeDistributorContract.address)
	const lastTokenBalance = await feeDistributorContract.token_last_balance()
	let freeBalance = balance.sub(lastTokenBalance)

	const lastTokenTime = await feeDistributorContract.last_token_time()

	const epochStart = lastTokenTime.div(week).mul(week)
	const epochEnd = epochStart.add(week) // time when checkpoint will be done

	const now = BigNumber.from(Math.floor(Date.now() / 1000))
	if (epochEnd.lt(now)) {
		const sinceLast = now.sub(lastTokenTime)
		const diff = epochEnd.sub(lastTokenTime)
		freeBalance = freeBalance.mul(diff).div(sinceLast)
	}

	const existBalance = await feeDistributorContract.tokens_per_week(
		epochStart
	)

	const totalBalance = freeBalance.add(existBalance)
	if (totalBalance.eq(0)) {
		return await feeDistributorContract.tokens_per_week(
			epochStart.sub(week) // rewards from prev week
		)
	}
	return totalBalance
}
